export * from './sync-faild.component'